// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Dropdown = require("./BrowserComponents_Dropdown.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

function buttonContainer(dropdownStatus) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.backgroundColor(dropdownStatus ? ({
                          TAG: /* White */7,
                          _0: /* Light */2
                        }) : ({
                          TAG: /* Grey */2,
                          _0: /* Lightest */4
                        })),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.rem(1.0)),
                  tl: {
                    hd: BrowserStyle.flex({
                          NAME: "num",
                          VAL: 0.0
                        }),
                    tl: {
                      hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
                      tl: {
                        hd: BrowserStyle.justifyContent(BrowserStyle.center),
                        tl: {
                          hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            });
}

var dropdownContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* White */7,
            _0: /* Light */2
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
        tl: {
          hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
          tl: {
            hd: BrowserStyle.boxShadow(/* Medium */2),
            tl: {
              hd: BrowserStyle.marginTop(BrowserStyle.rem(0.375)),
              tl: {
                hd: BrowserStyle.padding(BrowserStyle.Spacing.small),
                tl: {
                  hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
                  tl: {
                    hd: BrowserStyle.width(BrowserStyle.unset),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

function arg(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Semibold */1);
}

var actionItem = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined, undefined), /* [] */0));

var Styles = {
  buttonContainer: buttonContainer,
  dropdownContainer: dropdownContainer,
  actionItem: actionItem
};

function BrowserComponents_KebabMenu(Props) {
  var actions = Props.actions;
  var className = Props.className;
  var disabledOpt = Props.disabled;
  var horizontalOrientationOpt = Props.horizontalOrientation;
  var onBlur = Props.onBlur;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var horizontalOrientation = horizontalOrientationOpt !== undefined ? horizontalOrientationOpt : /* Left */0;
  var match = BrowserComponents_Dropdown.Base.useExpandedState(undefined, true, disabled, undefined);
  var status = match.status;
  var match$1 = Curry._2(BrowserStyle.Input.useInput(undefined)(disabled), onBlur, undefined);
  var onBlur$1 = match$1.onBlur;
  var atLeastOneActionHasIcon = Relude_Option.isSome(Curry._2(Relude_Array.find, (function (param) {
              return Relude_Option.isSome(param.icon);
            }), actions));
  var tmp = {
    buttonContent: React.createElement(BrowserComponents_FlexColumn.make, {
          className: buttonContainer(status),
          children: React.createElement(BrowserComponents_Icon.make, {
                icon: {
                  TAG: /* Small */1,
                  _0: {
                    TAG: /* Navigation */5,
                    _0: /* MoreVertical */6
                  }
                }
              })
        }),
    buttonTabIndex: /* NotTabbable */0,
    children: Relude_Array.mapWithIndex((function (param, index) {
            var icon = param.icon;
            var tmp = {
              children: param.title,
              className: actionItem,
              isSelected: false,
              onSelectItem: param.onClick,
              showSeparator: false,
              size: /* Medium */2,
              key: "action" + Relude_Int.toString(index)
            };
            var tmp$1 = Relude_Option.fold(atLeastOneActionHasIcon ? ({
                      TAG: /* Navigation */5,
                      _0: /* Settings */16
                    }) : undefined, Relude_Option.pure, icon);
            if (tmp$1 !== undefined) {
              tmp.icon = Caml_option.valFromOption(tmp$1);
            }
            var tmp$2 = Relude_Option.fold(/* Transparent */2, (function (param) {
                    return Relude_Globals.$$const(undefined, param);
                  }), icon);
            if (tmp$2 !== undefined) {
              tmp.iconColor = Caml_option.valFromOption(tmp$2);
            }
            return React.createElement(BrowserComponents_Dropdown.Item.make, tmp);
          }), actions),
    containerClassName: (function (param, param$1) {
        return dropdownContainer;
      }),
    horizontalOrientation: horizontalOrientation,
    onBlur: (function (param) {
        return Relude_Globals.$$const(onBlur$1, param);
      }),
    onClick: match.onClick,
    onFocus: match$1.onFocus,
    status: status,
    styleType: match$1.styleType
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_Dropdown.Base.Stateless.make, tmp);
}

var make = BrowserComponents_KebabMenu;

exports.Styles = Styles;
exports.make = make;
/* dropdownContainer Not a pure module */
